module.exports = {"622921100":"韩集镇","622921101":"土桥镇","622921102":"马集镇","622921103":"莲花镇","622921104":"新集镇","622921105":"尹集镇","622921106":"刁祁镇","622921107":"北塬镇","622921108":"黄泥湾镇","622921200":"营滩乡","622921201":"掌子沟乡","622921202":"麻尼寺沟乡","622921204":"漠泥沟乡","622921208":"漫路乡","622921209":"榆林乡","622921210":"井沟乡","622921213":"坡头乡","622921214":"桥寺乡","622921215":"先锋乡","622921216":"河西乡","622921217":"安家坡乡","622921218":"南塬乡","622921220":"红台乡","622921223":"路盘乡","622921224":"民主乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/622921.json
// module id = 2964
// module chunks = 0